import { render, staticRenderFns } from "./bautagebuch.vue?vue&type=template&id=05e170cb&"
import script from "./bautagebuch.vue?vue&type=script&lang=js&"
export * from "./bautagebuch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports